import React from 'react';
import styled from 'styled-components';

import { mediaQueries } from 'shared/styles';
import { Logo } from 'shared/assets/logo';
import { BaseSlideWrapper, BaseSlideContent, BaseSlideCta, BaseSlideImage } from './login.styles';

export const Spring26 = (): JSX.Element => (
  <Wrapper>
    <Logo fill='#F0E7D4' />
    <Content>
      <Heading>
        February
        <br />
        product updates
      </Heading>

      <Cta
        href='https://business.dutchie.com/post/february-26-product-updates?utm_source=ecomm&utm_medium=login&utm_campaign=productupdatesfeb26'
        target='_blank'
        rel='noreferrer'
      >
        See it in action
      </Cta>

      <Images>
        <BaseSlideImage
          src='https://images.dutchie.com/admin-login/spring-26/refer-a-friend.png'
          alt='Screenshots of new Refer a Friend feature'
          width={233}
        />
        <BaseSlideImage
          src='https://images.dutchie.com/admin-login/spring-26/loyalty-signup.png'
          alt='Screenshots of new Loyalty Signup feature'
          width={319}
        />
        <BaseSlideImage
          src='https://images.dutchie.com/admin-login/spring-26/vip-menus.png'
          alt='Screenshots of new VIP Menus feature'
          width={218}
        />
      </Images>
    </Content>
  </Wrapper>
);

const Wrapper = styled(BaseSlideWrapper)`
  background: #062f22;
  padding-top: 58px;
`;

const Content = styled(BaseSlideContent)`
  color: #f0e7d4;
  padding-top: 166px;
  width: 100%;
`;

const Heading = styled.h1`
  color: #f0e7d4;
  text-align: center;
  font-family: Matter;
  font-size: 60px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media ${mediaQueries.belowMedium} {
    font-size: 48px;
  }
`;

const Cta = styled(BaseSlideCta)`
  margin-top: 48px;
  background: #ffc02a;
  color: #062f22;

  &:hover {
    background: none;
    box-shadow: inset 0 0 0 2px #fff7ef;
    color: #fff7ef;
  }
`;

const Images = styled.div`
  margin-top: 85px;
  display: flex;
  flex-direction: row;
  gap: 19px;
  width: 100%;

  img {
    min-width: 0;
  }
`;
